module.exports = __webpack_public_path__ + "img/pennstate.c24ff4ca.png";